import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

@Injectable({
    providedIn: 'root'
})
export class FAQService {
    baseUrl = environment.API_BASE_PATH;

    constructor(private commonService: CommonService, private http: HttpClient) {
    }

    getFaqList(index, rows, column, direction, search): Observable<void> {
        let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(this.baseUrl + '/faqs', headers);
    }

    addfaq(data): Observable<any> {
        return this.commonService.postCall(this.baseUrl + '/faqs', data);
    }

    updatefaq(data): Observable<any> {
        return this.commonService.putCall(this.baseUrl + '/faqs', data);
    }

    deletefaq(id): Observable<any> {
        return this.commonService.deleteCall(this.baseUrl + '/faqs/' + id);
    }
}